import '@boomi/exosphere/dist/styles.css';
import './forms.css';
import './index.css';
import { LoginCallback } from '@okta/okta-react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import Loading from './Loading.tsx';
import ProtectedApp from './ProtectedApp.tsx';
import { RequiredAuth } from './SecureRoute.tsx';
import AlertPopupList from './alertPopups/AlertPopupList.tsx';
import { AppProvider } from './common/AppProvider.tsx';
import Content from './common/Content.tsx';
import Footer from './common/Footer.tsx';
import TaskAutomationHeader from './common/TaskAutomationHeader.tsx';
import Connections from './connections/Connections.tsx';
import Notifications from './notifications/Notifications.tsx';
import Profile from './profile/Profile.tsx';
import NewTaskConnectors from './tasks-new/NewTaskConnectors.tsx';
import NewTaskSuggestions from './tasks-new/NewTaskSuggestions.tsx';
import Task from './tasks/Task.tsx';
import Tasks from './tasks/Tasks.tsx';
import WelcomeBanner from './tasks/WelcomeBanner.tsx';
import { translations } from './translations/translations.ts';
import TaskLogs from './taskLogs/TaskLogs.tsx';
import Webhooks from './webhooks/webhooks.tsx';
import BoomiHeader from './common/BoomiHeader.tsx';

const router = createBrowserRouter([
    {
        element: <ProtectedApp />,
        children: [
            {
                element: <RequiredAuth language={'en'} />,
                children: [
                    {
                        element: <AppProvider />,
                        children: [
                            {
                                element: (
                                    <>
                                        <BoomiHeader />
                                        <TaskAutomationHeader />
                                        <Outlet />
                                        <Footer />
                                        <AlertPopupList />
                                    </>
                                ),
                                children: [
                                    {
                                        path: '/',
                                        element: (
                                            <Loading message={translations['en'].COMMON_loading} />
                                        ),
                                    },
                                    {
                                        path: '/tasks',
                                        element: (
                                            <>
                                                <WelcomeBanner />
                                                <Content>
                                                    <Tasks />
                                                </Content>
                                            </>
                                        ),
                                    },
                                    {
                                        path: '/tasks/new',
                                        element: (
                                            <Content>
                                                <NewTaskConnectors />
                                            </Content>
                                        ),
                                    },
                                    {
                                        path: '/tasks/new/suggestions',
                                        element: (
                                            <Content>
                                                <NewTaskSuggestions />
                                            </Content>
                                        ),
                                    },
                                    {
                                        path: '/tasks/new-task',
                                        element: <Task />,
                                    },
                                    {
                                        path: '/tasks/:id',
                                        element: <Task />,
                                        errorElement: (
                                            <div>
                                                <h1>404</h1>
                                            </div>
                                        ),
                                    },
                                    {
                                        path: '/tasks/history',
                                        element: (
                                            <Content>
                                                <TaskLogs />
                                            </Content>
                                        ),
                                        errorElement: (
                                            <div>
                                                <h1>404</h1>
                                            </div>
                                        ),
                                    },
                                    {
                                        path: '/profile',
                                        element: (
                                            <Content>
                                                <Profile />
                                            </Content>
                                        ),
                                    },
                                    {
                                        path: '/connections',
                                        element: (
                                            <Content>
                                                <Connections />
                                            </Content>
                                        ),
                                    },
                                    {
                                        path: '/notifications',
                                        element: (
                                            <Content>
                                                <Notifications />
                                            </Content>
                                        ),
                                    },
                                    {
                                        path: '/webhooks',
                                        element: (
                                            <Content>
                                                <Webhooks />
                                            </Content>
                                        ),
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'login/callback',
                element: <LoginCallback />,
            },
        ],
    },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <RouterProvider router={router} />
    </StrictMode>,
);
